/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-undef */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext, FieldArray } from 'formik';
import { ModalGeneric } from 'ypf-pas-general-ui-components';
import dayjs from 'dayjs';

import ServiceAccordion from '../ServiceAccordion/ServiceAccordion';
import { initialValuesSDS, stepEnumOfAccordion } from '../../Constants';
import { getRandomKey } from '../../../../utils/formatUtils';
import { ubicationTypeEnum } from '../../../../utils/dataStatus';

import './ListOfAccordions.scss';

const ListOfAccordions = ({
  notificationOptions,
  addDeletedServiceRequest,
  isAutocomplete,
  isApplyTemplateRequest,
  setStep,
  setShow,
  disabledAllFields
}) => {
  const { values } = useFormikContext();

  const [accordionOpen, setAccordionOpen] = useState();

  const [modalState, setModalState] = useState({
    showModal: false,
    dataService: {
      fecha: '',
      nombre: ''
    },
    removeService: () => {}
  });

  const handleModalState = (openModal, removeServiceFunction, dataService) => {
    setModalState({
      showModal: openModal,
      removeService: removeServiceFunction,
      dataService
    });
  };

  const closeModal = () => {
    setModalState({
      ...modalState,
      showModal: false
    });
  };

  const backToUbicationForm = () => {
    setStep(stepEnumOfAccordion.ubicacion);
    setShow(false);
    setAccordionOpen(null);
  };

  useEffect(() => {
    if (values?.accordions?.length === 1 && isApplyTemplateRequest) {
      setAccordionOpen(null);
    }
  }, [isApplyTemplateRequest, values?.accordions?.length]);

  useEffect(() => {
    const event = values?.ubication?.event;
    const team = values?.ubication?.team;
    const typeLocation = values?.ubication?.ubicationType?.id;

    if ((!event || !team) && typeLocation === ubicationTypeEnum.pozo && isApplyTemplateRequest) {
      setAccordionOpen(null);
      setShow(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.ubication?.event, values?.ubication?.team, values?.ubication?.ubicationType?.id]);

  return (
    <div>
      <FieldArray
        name="accordions"
        render={(arrayHelpers) =>
          values?.accordions?.map((accordion, accordionIndex) => (
            <ServiceAccordion
              accordionIndex={accordionIndex}
              backToUbicationForm={backToUbicationForm}
              disabledAllFields={disabledAllFields}
              handleModalState={handleModalState}
              insertAccordion={(index, needDate, probDate) =>
                arrayHelpers.insert(index + 1, {
                  ...initialValuesSDS.accordions[0],
                  accordionStep: 2,
                  accordionId: getRandomKey(),
                  service: {
                    currentStepService: null,
                    service: null,
                    probDate,
                    needDate,
                    description: ''
                  }
                })
              }
              isApplyTemplateRequest={isApplyTemplateRequest}
              isAutocomplete={isAutocomplete}
              key={accordion?.accordionId}
              notificationOptions={notificationOptions}
              removeAccordion={() => {
                if (accordionOpen === accordionIndex) {
                  setAccordionOpen(null);
                }
                const accordionToDelete = values?.accordions[accordionIndex];

                addDeletedServiceRequest(accordionToDelete);
                arrayHelpers.remove(accordionIndex);
              }}
              setAccordionOpen={setAccordionOpen}
              showContentAccordion={accordionIndex === accordionOpen}
            />
          ))
        }
      />
      <div>
        <ModalGeneric
          backdrop="static"
          centered
          infoModal
          onHide={closeModal}
          primaryAction={() => {
            modalState.removeService();
            closeModal();
          }}
          primaryActionLabel="Aceptar"
          secondaryAction={closeModal}
          secondaryActionLabel="Salir"
          show={modalState.showModal}
          size="md"
          title="Eliminar Servicio de la solicitud"
          variantHeader="danger"
        >
          {modalState?.dataService?.fecha && modalState?.dataService?.nombre ? (
            <div className="modal_delete_multiple_service_request">
              ¿Querés eliminar el servicio{' '}
              <b>"{`${dayjs(modalState?.dataService.fecha).format('DD/MM/YYYY')}`}</b>{' '}
              <b>- {modalState.dataService.nombre}"</b> de la solicitud de servicio?
            </div>
          ) : (
            <div className="modal_delete_multiple_service_request">
              ¿Querés eliminar este servicio de la solicitud?
            </div>
          )}
        </ModalGeneric>
      </div>
    </div>
  );
};

ListOfAccordions.propTypes = {
  disabledAllFields: PropTypes.bool,
  isAutocomplete: PropTypes.bool,
  isApplyTemplateRequest: PropTypes.bool,
  notificationOptions: PropTypes.arrayOf(PropTypes.shape({})),
  addDeletedServiceRequest: PropTypes.func.isRequired,
  setStep: PropTypes.func.isRequired,
  setShow: PropTypes.func.isRequired
};

ListOfAccordions.defaultProps = {
  disabledAllFields: false,
  notificationOptions: [],
  isAutocomplete: false,
  isApplyTemplateRequest: false
};

export default ListOfAccordions;
